import React from 'react';
import { Box } from '@mui/material';
import type { Components } from 'react-markdown';
import {
  isNegativeMarkdownTableCell,
  normalizeMarkdownTableCellText,
} from '../utils/markdownTableNegativeValue';
import { MarkdownTableWrapper } from '../styled';

function getPlainText(node: React.ReactNode): string {
  if (typeof node === 'string') return node;
  if (Array.isArray(node)) return node.map(getPlainText).join('');
  if (node && typeof node === 'object' && 'props' in (node as object)) {
    return getPlainText((node as React.ReactElement).props?.children);
  }
  return '';
}

function isMarkdownTableStatusCell(text: string): boolean {
  return (
    /^keep$/i.test(text) ||
    /^monitor$/i.test(text) ||
    /^retest$/i.test(text) ||
    /^cut\s*\/\s*replace$/i.test(text) ||
    /^cut$/i.test(text)
  );
}

type StatusChipRenderer = React.ComponentType<{ value: string }>;

export function createRemarkGfmMarkdownComponents(
  renderStatusChip: StatusChipRenderer,
): Components {
  return {
    table: ({ children, ...props }) => (
      <MarkdownTableWrapper>
        <table {...props}>{children}</table>
      </MarkdownTableWrapper>
    ),
    td: ({ children, ...props }) => {
      const text = normalizeMarkdownTableCellText(getPlainText(children));
      if (isMarkdownTableStatusCell(text)) {
        const StatusChip = renderStatusChip;
        return (
          <td {...props}>
            <StatusChip value={text} />
          </td>
        );
      }
      if (isNegativeMarkdownTableCell(text)) {
        return (
          <td {...props}>
            <Box component="span" sx={{ color: 'error.main', fontWeight: 600 }}>
              {text}
            </Box>
          </td>
        );
      }
      return <td {...props}>{children}</td>;
    },
  };
}
